import validate from "/runner/_work/nova-widget/nova-widget/node_modules/.pnpm/nuxt@3.5.2_@types+node@18.17.1_eslint@8.45.0_sass@1.64.1_stylelint@15.10.2_typescript@5.1.6_vue-tsc@2.0.7/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45toggles_45global from "/runner/_work/nova-widget/nova-widget/domains/core/middleware/01.toggles.global.ts";
import _02_45contexted_45error_45global from "/runner/_work/nova-widget/nova-widget/domains/core/middleware/02.contexted-error.global.ts";
import persist_45query_45global from "/runner/_work/nova-widget/nova-widget/domains/core/middleware/persistQuery.global.ts";
export const globalMiddleware = [
  validate,
  _01_45toggles_45global,
  _02_45contexted_45error_45global,
  persist_45query_45global
]
export const namedMiddleware = {}